module.exports = "<header>\n  <div *ngIf=\"showCookieNotice\">\n    Accetta i cookie\n    <button class=\"btn btn-default\" (click)=\"acceptCookie()\">Accetto</button>\n  </div>\n  <nav>\n    <div>\n      <a [routerLink]=\"['/']\">Home</a> |\n      <a [routerLink]=\"['/storico-quotazioni']\">History</a>\n    </div>\n  </nav>\n</header>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/header/header.component.html
// module id = 744
// module chunks = 1